package org.multipaz.utopia.generated

/**
 * Generated strings for language: tr
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_tr = mapOf(
    "boarding_pass_attribute_departure_time" to "Kalkış saati",
    "boarding_pass_attribute_flight_number" to "Uçuş numarası",
    "boarding_pass_attribute_passenger_name" to "Yolcu adı",
    "boarding_pass_attribute_seat_number" to "Koltuk numarası",
    "boarding_pass_description_departure_time" to "Kalkış tarihi ve saati",
    "boarding_pass_description_flight_number" to "Uçuş numarası",
    "boarding_pass_description_passenger_name" to "mDL sahibinin soyadı, adı veya birincil tanımlayıcısı.",
    "boarding_pass_description_seat_number" to "Koltuk numarası",
    "cor_attribute_administrative_number" to "İdari numara",
    "cor_attribute_date_of_arrival" to "Varış tarihi",
    "cor_attribute_date_of_birth" to "Doğum tarihi",
    "cor_attribute_date_of_expiry" to "Geçerlilik bitiş tarihi",
    "cor_attribute_date_of_issue" to "Düzenlenme tarihi",
    "cor_attribute_document_number" to "Belge numarası",
    "cor_attribute_family_name" to "Soyadı",
    "cor_attribute_gender" to "Cinsiyet",
    "cor_attribute_given_names" to "Ad(lar)",
    "cor_attribute_issuing_authority" to "Düzenleyen makam",
    "cor_attribute_issuing_country" to "Düzenleyen ülke",
    "cor_attribute_issuing_jurisdiction" to "Düzenleyen yargı alanı",
    "cor_attribute_nationality" to "Uyruk",
    "cor_attribute_older_than_18" to "18 yaşından büyük",
    "cor_attribute_older_than_21" to "21 yaş üstü",
    "cor_attribute_place_of_birth" to "Doğum yeri",
    "cor_attribute_resident_address" to "İkamet adresi",
    "cor_attribute_resident_city" to "İkamet şehri",
    "cor_attribute_resident_country" to "İkamet ülkesi",
    "cor_attribute_resident_house_number" to "İkamet kapı numarası",
    "cor_attribute_resident_postal_code" to "İkamet posta kodu",
    "cor_attribute_resident_state" to "İkamet eyaleti",
    "cor_attribute_resident_street" to "İkamet sokağı",
    "cor_description_administrative_number" to "Denetim kontrolü veya diğer amaçlar için COR Sağlayıcı tarafından atanan bir numara.",
    "cor_description_date_of_arrival" to "COR sahibinin AB'ye geldiği gün, ay ve yıl.",
    "cor_description_date_of_birth" to "COR sahibinin doğduğu gün, ay ve yıl. Bilinmiyorsa, yaklaşık doğum tarihi.",
    "cor_description_date_of_expiry" to "İkamet Belgesi'nin sona erme tarihi (ve muhtemelen saati).",
    "cor_description_date_of_issue" to "İkamet Belgesi'nin düzenlenme tarihi (ve muhtemelen saati).",
    "cor_description_document_number" to "COR Sağlayıcı tarafından atanan bir COR numarası.",
    "cor_description_family_name" to "COR sahibinin mevcut soyadı/soyadları veya birincil kimliği",
    "cor_description_gender" to "İkamet Belgesi sahibinin cinsiyeti.",
    "cor_description_given_names" to "COR sahibinin mevcut adı/adları, diğer adı/adları veya ikincil kimliği",
    "cor_description_issuing_authority" to "Bu COR örneğini düzenleyen idari makamın adı veya COR düzenlemeye yetkili ayrı bir makam yoksa ilgili Üye Devletin ISO 3166 Alfa-2 ülke kodu.",
    "cor_description_issuing_country" to "Düzenleyici makamın ülkesinin veya bölgesinin, ISO 3166-1'de tanımlandığı üzere Alfa-2 ülke kodu.",
    "cor_description_issuing_jurisdiction" to "COR'u düzenleyen yetki alanının, ISO 3166-2:2020, Madde 8'de tanımlandığı üzere ülke alt bölüm kodu. Kodun ilk kısmı, issuing_country değeriyle aynı OLMALIDIR.",
    "cor_description_nationality" to "Kullanıcının uyruğunu temsil eden, ISO 3166-1'de belirtilen Alfa-2 ülke kodu.",
    "cor_description_older_than_18" to "18 yaşından büyük mü?",
    "cor_description_older_than_21" to "21 yaşından büyük mü?",
    "cor_description_place_of_birth" to "İkamet Belgesi sahibinin doğduğu yer.",
    "cor_description_resident_address" to "COR sahibinin şu anda ikamet ettiği ve/veya iletişime geçilebilecek yerin tam adresi (cadde/kapı numarası, belediye vb.)",
    "cor_description_resident_city" to "İkamet Belgesi sahibinin mevcut ikamet ettiği şehir.",
    "cor_description_resident_country" to "Kullanıcının şu anda ikamet ettiği ülke, ISO 3166-1'de belirtilen Alpha-2 ülke kodu olarak",
    "cor_description_resident_house_number" to "Kullanıcının mevcut ikamet ettiği ev numarası (ek veya son ekler dahil).",
    "cor_description_resident_postal_code" to "İkamet Belgesi sahibinin mevcut ikamet ettiği yerin posta kodu.",
    "cor_description_resident_state" to "Kullanıcının mevcut ikamet ettiği eyalet, il, bölge veya yerel konum.",
    "cor_description_resident_street" to "Kullanıcının mevcut ikamet ettiği sokağın adı.",
    "cor_request_age_over_18" to "18 yaş üstü",
    "cor_request_all_data_elements" to "Tüm veri öğeleri",
    "cor_request_mandatory_data_elements" to "Zorunlu veri öğeleri",
    "document_display_name_boarding_pass" to "Biniş kartı",
    "document_display_name_certificate_of_residency" to "İkametgah Belgesi",
    "document_display_name_german_personal_id" to "Alman kimlik kartı",
    "document_display_name_loyalty_card" to "Sadakat kartı",
    "document_display_name_movie_ticket" to "Sinema bileti",
    "document_display_name_naturalization_certificate" to "Vatandaşlığa kabul belgesi",
    "document_display_name_payment_card" to "Ödeme kartı",
    "german_id_attribute_administrative_number" to "İdari numara",
    "german_id_attribute_age_in_years" to "Yaş (yıl olarak)",
    "german_id_attribute_city_of_birth" to "Doğum şehri",
    "german_id_attribute_country_of_birth" to "Doğum ülkesi",
    "german_id_attribute_date_of_birth" to "Doğum tarihi",
    "german_id_attribute_date_of_expiry" to "Geçerlilik tarihi",
    "german_id_attribute_date_of_issue" to "Düzenlenme tarihi",
    "german_id_attribute_document_number" to "Belge numarası",
    "german_id_attribute_family_name" to "Soyadı",
    "german_id_attribute_family_name_at_birth" to "Doğumdaki soyadı",
    "german_id_attribute_gender" to "Cinsiyet",
    "german_id_attribute_given_names" to "Ad",
    "german_id_attribute_issuing_authority" to "Düzenleyen makam",
    "german_id_attribute_issuing_country" to "Düzenleyen ülke",
    "german_id_attribute_issuing_jurisdiction" to "Düzenleyen yargı alanı",
    "german_id_attribute_nationality" to "Uyruk",
    "german_id_attribute_older_than_12" to "12 yaşından büyük",
    "german_id_attribute_older_than_14" to "14 yaşından büyük",
    "german_id_attribute_older_than_16" to "16 yaşından büyük",
    "german_id_attribute_older_than_18" to "18 yaşından büyük",
    "german_id_attribute_older_than_21" to "21 yaşından büyük",
    "german_id_attribute_older_than_65" to "65 yaşından büyük",
    "german_id_attribute_place_of_birth" to "Doğum yeri",
    "german_id_attribute_resident_address" to "İkamet adresi",
    "german_id_attribute_resident_city" to "İkametgah şehri",
    "german_id_attribute_resident_country" to "İkametgah ülkesi",
    "german_id_attribute_resident_postal_code" to "İkametgah posta kodu",
    "german_id_attribute_state_of_birth" to "Doğum eyaleti",
    "german_id_attribute_year_of_birth" to "Doğum yılı",
    "german_id_description_administrative_number" to "PID Sağlayıcısı tarafından denetim kontrolü veya diğer amaçlar için atanmış bir numara.",
    "german_id_description_age_in_years" to "PID sahibinin yaşı (yıl cinsinden)",
    "german_id_description_city_of_birth" to "PID Kullanıcısının doğduğu belediye, şehir, kasaba veya köy",
    "german_id_description_country_of_birth" to "Kimlik sahibinin doğduğu ülke, ISO 3166-1'de belirtildiği gibi Alfa-2 ülke kodu olarak",
    "german_id_description_date_of_birth" to "PID sahibinin doğduğu gün, ay ve yıl. Bilinmiyorsa, tahmini doğum tarihi.",
    "german_id_description_date_of_expiry" to "PID'in sona erme tarihi (ve muhtemelen saati)",
    "german_id_description_date_of_issue" to "PID'in düzenlenme tarihi (ve muhtemelen saati)",
    "german_id_description_document_number" to "PID için, PID Sağlayıcısı tarafından atanmış bir numara.",
    "german_id_description_family_name" to "PID sahibinin güncel soyadı(ları) veya birincil kimliği",
    "german_id_description_family_name_at_birth" to "Doğumdaki soyadı/soyadları veya kimlik sahibinin birincil tanımlayıcısı",
    "german_id_description_gender" to "PID sahibinin cinsiyeti",
    "german_id_description_given_names" to "PID sahibinin güncel adı(adları), diğer adı(adları) veya ikincil kimliği",
    "german_id_description_issuing_authority" to "Bu PID örneğini düzenleyen idari makamın adı veya PID'leri düzenlemeye yetkili ayrı bir makamın olmaması durumunda ilgili Üye Devletin ISO 3166 Alfa-2 ülke kodu",
    "german_id_description_issuing_country" to "Düzenleyici makamın ülkesi veya bölgesinin, ISO 3166-1'de tanımlandığı gibi Alfa-2 ülke kodu.",
    "german_id_description_issuing_jurisdiction" to "PID'i düzenleyen yargı yetkisinin ülke alt bölüm kodu (ISO 3166-2:2020, Madde 8'de tanımlandığı gibi). Kodun ilk kısmı, düzenleyen ülke değerinin aynısı OLMALIDIR.",
    "german_id_description_nationality" to "PID Kullanıcısının uyruğunu temsil eden, ISO 3166-1'de belirtilen Alfa-2 ülke kodları listesi",
    "german_id_description_older_than_12" to "12 yaşından büyük mü?",
    "german_id_description_older_than_14" to "14 yaşından büyük mü?",
    "german_id_description_older_than_16" to "16 yaşından büyük mü?",
    "german_id_description_older_than_18" to "18 yaşından büyük mü?",
    "german_id_description_older_than_21" to "21 yaşından büyük mü?",
    "german_id_description_older_than_65" to "65 yaşından büyük mü?",
    "german_id_description_place_of_birth" to "Kimlik sahibinin doğduğu ülke ve belediye veya eyalet/il",
    "german_id_description_resident_address" to "PID sahibinin mevcut ikamet ettiği ve/veya ulaşılabileceği yerin tam adresi (sokak/kapı numarası, belediye vb.)",
    "german_id_description_resident_city" to "PID sahibinin mevcut ikamet ettiği şehir",
    "german_id_description_resident_country" to "PID Kullanıcısının şu anda ikamet ettiği ülke, ISO 3166-1'de belirtildiği üzere bir Alfa-2 ülke kodu olarak",
    "german_id_description_resident_postal_code" to "PID sahibinin mevcut ikamet ettiği yerin posta kodu",
    "german_id_description_state_of_birth" to "Kimlik sahibinin doğduğu eyalet, il, ilçe veya yerel bölge",
    "german_id_description_year_of_birth" to "PID sahibinin doğum yılı",
    "german_id_request_age_over_18" to "18 yaşından büyük",
    "german_id_request_all_data_elements" to "Tüm veri öğeleri",
    "german_id_request_mandatory_data_elements" to "Zorunlu veri öğeleri",
    "loyalty_attribute_date_of_expiry" to "Son kullanma tarihi",
    "loyalty_attribute_date_of_issue" to "Veriliş tarihi",
    "loyalty_attribute_family_name" to "Soyadı",
    "loyalty_attribute_given_names" to "Adı",
    "loyalty_attribute_membership_id" to "Üyelik Kimliği",
    "loyalty_attribute_photo_of_holder" to "Sahibinin fotoğrafı",
    "loyalty_attribute_tier" to "Seviye",
    "loyalty_description_date_of_expiry" to "Belgenin sona erme tarihi",
    "loyalty_description_date_of_issue" to "Belgenin düzenlenme tarihi",
    "loyalty_description_family_name" to "Belge sahibinin soyadı veya birincil tanımlayıcısı",
    "loyalty_description_given_names" to "Belge sahibinin adı/adları, diğer adları veya ikincil tanımlayıcısı",
    "loyalty_description_membership_id" to "Sadakat Kimliği sahibinin kişisel tanımlayıcısı",
    "loyalty_description_photo_of_holder" to "Belge sahibinin fotoğrafı",
    "loyalty_description_tier" to "Üyelik seviyesi (temel, gümüş, altın, platin, elit)",
    "loyalty_request_all_data_elements" to "Tüm veri öğeleri",
    "loyalty_request_mandatory_data_elements" to "Zorunlu veri öğeleri",
    "movie_ticket_attribute_age_rating_code" to "Yaş sınırı kodu",
    "movie_ticket_attribute_cinema_theater" to "Sinema salonu",
    "movie_ticket_attribute_date_and_time_of_show" to "Seans tarihi ve saati",
    "movie_ticket_attribute_movie_poster" to "Film afişi",
    "movie_ticket_attribute_movie_title" to "Film adı",
    "movie_ticket_attribute_parking" to "Otopark",
    "movie_ticket_attribute_seat" to "Koltuk",
    "movie_ticket_attribute_theater" to "Salon",
    "movie_ticket_attribute_ticket_number" to "Bilet numarası",
    "movie_ticket_description_age_rating_code" to "Film yaş derecelendirme kodu",
    "movie_ticket_description_cinema_theater" to "Sinema salonu adı ve/veya giriş adresi/konumu.",
    "movie_ticket_description_date_and_time_of_show" to "Gösterim tarihi ve saati",
    "movie_ticket_description_movie_poster" to "Film Afişi",
    "movie_ticket_description_movie_title" to "Film adı, başlığı ve diğer gösteri kimlik bilgileri.",
    "movie_ticket_description_parking" to "Otopark (biletle ön ödemeli mi?)",
    "movie_ticket_description_seat" to "Koltuk numarası veya kodu (örn. sıra/koltuk)",
    "movie_ticket_description_theater" to "Sinema salonu adı veya numarası",
    "movie_ticket_description_ticket_number" to "Satın alma anında verilen bilet kimlik/referans numarası.",
    "movie_ticket_request_all_data_elements" to "Tüm veri öğeleri",
    "movie_ticket_request_prepaid_parking" to "Ön ödemeli otopark",
    "movie_ticket_request_ticket_number" to "Bilet numarası",
    "naturalization_attribute_date_of_birth" to "Doğum tarihi",
    "naturalization_attribute_date_of_naturalization" to "Vatandaşlığa kabul tarihi",
    "naturalization_attribute_family_name" to "Soyadı",
    "naturalization_attribute_given_names" to "Adlar",
    "naturalization_description_date_of_birth" to "Vatandaşlığa kabul edilen kişinin doğduğu gün, ay ve yıl. Bilinmiyorsa, yaklaşık doğum tarihi.",
    "naturalization_description_date_of_naturalization" to "Kişinin vatandaşlığa kabul edildiği tarih (ve muhtemelen saat).",
    "naturalization_description_family_name" to "Vatandaşlığa kabul edilen kişinin mevcut soyadı/soyadları veya birincil kimliği",
    "naturalization_description_given_names" to "Vatandaşlığa kabul edilen kişinin mevcut adı/adları, diğer adı/adları veya ikincil kimliği",
    "naturalization_request_all_data_elements" to "Tüm veri öğeleri",
    "payment_attribute_expiry_date" to "Son kullanma tarihi",
    "payment_attribute_holder_name" to "Kart sahibi adı",
    "payment_attribute_issue_date" to "Düzenleme tarihi",
    "payment_attribute_issuer_name" to "İhraççı adı",
    "payment_attribute_masked_account_reference" to "Maskelenmiş hesap referansı",
    "payment_attribute_payment_instrument_id" to "Ödeme aracı kimliği",
    "payment_description_expiry_date" to "Bu kimlik bilgisinin sona erdiği tarih.",
    "payment_description_holder_name" to "Ödeme hesabı sahibi adı.",
    "payment_description_issue_date" to "Bu kimlik bilgisinin verildiği tarih.",
    "payment_description_issuer_name" to "Okunabilir ihraççı adı.",
    "payment_description_masked_account_reference" to "Maskeli hesap referansı, örneğin PAN son 4 hane.",
    "payment_description_payment_instrument_id" to "Tokenize edilmiş ödeme aracı tanımlayıcısı.",
    "payment_request_payment_sca_all" to "Ödeme SCA (tüm veri öğeleri)",
    "payment_request_payment_sca_minimal" to "Ödeme SCA (minimal)",
    "payment_request_payment_sca_transaction" to "Ödeme işlemiyle Ödeme SCA'sı"
)
